export default __webpack_public_path__ + "a0f07ca01c58e914052ff8992bfa2255.jpg";